import React, {useEffect, useState} from 'react';
import {ReactComponent as CloseIcon} from '../../../../assets/form/close-form.svg';
import {ReactComponent as SelectArrayIcon} from '../../../../assets/i/select-array-icon.svg';
import {ReactComponent as ArrowUpIconIcon} from '../../../../assets/i/arrow-up-icon.svg';
import {useAppDispatch, useAppSelector} from "../../../../common/hook";
import {Form, Formik, useFormik} from "formik";
import {useInputWithFocus} from "../../../../common/hook/useInputWithFocus";
import {setFormFeedbackAC} from "../../../../app/popups-reducer";
import TextArea from "antd/es/input/TextArea";
import {Select} from "antd";
import {getLeaveReview} from "../../../../features/model/service/leave-review/getLeaveReview";
import {postLeaveReview} from "../../../../features/model/service/leave-review/postLeaveReview";
import {message} from 'antd';
import {setErrorSocials, setSuccessSocials} from "../../../../features/model/slice/leave-review/postLeaveReviewSlice";

interface MyFormValues {
    reviewText: string;
    socialNetwork: string;
}


export const FormFeedback = () => {
    const dispatch = useAppDispatch();
    const {isFilled, handleFocus, handleBlur} = useInputWithFocus([false, false]);
    const [countryOpen, setCountryOpen] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState<string>('');
    const socials = useAppSelector(state => state.socials.socials)
    const responseSocials = useAppSelector(state => state.postSocials)
    const {success, error} = responseSocials


    useEffect(() => {
        dispatch(getLeaveReview());
    }, [])


    const successMessage = () => {
        message.success('Отзыв успешно добавлен');
    };

    const OnClickCountryHandler = () => {
        setCountryOpen(!countryOpen);
    };

    const handleCountryChange = (value: string) => {
        setSelectedCountry(value);
    };

    const onClickHandler = () => {
        dispatch(setFormFeedbackAC(false));
    };

    const initialValues: MyFormValues = {
        reviewText: '',
        socialNetwork: '',
    };

    useEffect(() => {
        if (success) {
            successMessage();
            onClickHandler();
            dispatch(setSuccessSocials(false));
        } else if (error) {
            dispatch(setErrorSocials(null));
        }
    }, [success, error]);


    const handleSubmit = (values: MyFormValues) => {


        dispatch(postLeaveReview({
            text: values.reviewText,
            social: selectedCountry,
        }));
    };


    const formik = useFormik({
        initialValues,
        onSubmit: handleSubmit,
    });

    return (
        <Formik
            initialValues={initialValues}
            enableReinitialize={true}
            onSubmit={handleSubmit}
        >
            <>
                <p className="h3 popup-title">Оставить отзыв</p>
                <Form
                    className="form"
                    onSubmit={formik.handleSubmit}
                >
                    <div className="fields-row">
                        <div className={`field has-icon-inp ${isFilled[0] ? 'filled' : ''}`}>
                            <label className={`field-name ${formik.values.reviewText ? 'active-label' : ''}`}>Текст
                                отзыва</label>
                            <div className="textarea-box">
                                <TextArea
                                    className="form-control"
                                    name="reviewText"
                                    value={formik.values.reviewText}
                                    onChange={formik.handleChange}
                                    onFocus={() => handleFocus(0)}
                                    onBlur={handleBlur}
                                    autoSize={{minRows: 3, maxRows: 10}}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="fields-row">
                        <div className="field required auto-width">
                            <div style={{width: '100%'}}
                                 className={`field position`}>
                                <div className="course-type" onClick={OnClickCountryHandler}>
                                    <span
                                        className={selectedCountry ? 'active-label' : ''}>Мой профиль в</span>
                                    <Select
                                        style={{width: '100%'}}
                                        // status={`${errors.countryId ? 'error' : ''}`}
                                        options={socials}
                                        onFocus={() => handleFocus(1)}
                                        onBlur={handleBlur}
                                        onChange={(value) => {
                                            handleCountryChange(value);
                                        }}
                                        value={selectedCountry}
                                        suffixIcon={countryOpen ? <ArrowUpIconIcon/> : <SelectArrayIcon/>}
                                    />
                                </div>
                            </div>
                            {/*{errors.countryId && <p className="field-error">{errors.countryId}</p>}*/}
                        </div>
                    </div>
                    <button type="submit" className="btn full-width js-open-popup">
                        <span>Отправить отзыв</span>
                    </button>
                </Form>
                <span onClick={onClickHandler} className="js-close-popup">
                     <CloseIcon/>
                 </span>
            </>
        </Formik>
    );
};
